<template>
  <div class="grid bg-white">
    <div class="grid-title">
      <h4 class="heading semi-bold">Employees</h4>
    </div>
    <div class="grid-body">
      <div class="row">
        <div class="col-md-4">
          <div class="input-group transparent">
            <span class="input-group-addon">
              <i class="fa fa-search" aria-hidden="true"></i>
            </span>
            <input
              id="employee-filter"
              type="text"
              class="form-control search-table"
              placeholder="Keyword ..."
            />
          </div>
        </div>
        <div class="header-button-container col-md-8">
          <router-link
            :to="{ path: '/performance_scanning/employees/create' }"
            class="btn shadow btn-primary create-new-button"
            v-if="!isReadOnlyUser"
          >
            <i class="fa fa-plus-circle" aria-hidden="true"></i> Create New
            Employee
          </router-link>
        </div>
      </div>

      <div class="row mt-20">
        <div class="col-md-12">
          <div class="table-responsive">
            <vue-good-table
              mode="remote"
              :totalRows="totalRecords"
              :isLoading.sync="isLoading"
              :pagination-options="{
                enabled: true,
                mode: 'pages',
              }"
              styleClass="table table-bordered data-table"
              :rows="rows"
              :columns="columns"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'name'">
                  <router-link
                    :to="{
                      path:
                        '/performance_scanning/employees/edit/' + props.row.id,
                    }"
                  >
                    <strong
                      >{{ props.row.first_name }}
                      {{ props.row.last_name }}</strong
                    >
                  </router-link>
                </span>
                <span v-else-if="props.column.field == 'action_id'">
                  <router-link
                    :to="{
                      path:
                        '/performance_scanning/employees/edit/' + props.row.id,
                    }"
                    class="btn btn-success"
                    v-if="!isReadOnlyUser"
                  >
                    <i class="fa fa-edit" aria-hidden="true"></i> Edit
                  </router-link>
                  <button
                    type="button"
                    class="btn btn-danger"
                    @click="
                      deleteEmployee(props.row.id, props.row.originalIndex)
                    "
                    v-if="!isReadOnlyUser"
                  >
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </button>
                </span>
                <span v-else-if="props.column.field == 'befeni_tenure'">
                  {{ ezy.date(props.row.befeni_start) }} -
                  {{
                    props.row.befeni_end
                      ? ezy.date(props.row.befeni_end)
                      : "N/A"
                  }}
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TableHelper } from "@/pages/Tools/TableHelper.js";
import { VueGoodTable } from "vue-good-table";
import Fabric from "@/pages/Tools/Fabric";
import * as $ from "jquery";

export default {
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    new TableHelper({
      parent: this,
      endpoint: "/v2/performance_scanning/employees",
      filterSelector: "#employee-filter",
      filterColumns: ["id", "department"],
      sort: {
        id: "asc",
        department: "desc",
      },
    });
  },
  components: {
    VueGoodTable,
  },
  data() {
    return {
      isLoading: false,
      isReadOnlyUser: false,
      columns: [
        {
          label: "ID",
          field: "id",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Name",
          field: "name",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Nickname",
          field: "nickname",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Department",
          field: "department",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Position",
          field: "position",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Befeni Tenure",
          field: "befeni_tenure",
          sortable: false,
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Marital Status",
          field: "marital_status",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Children",
          field: "children",
          type: "number",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Action",
          field: "action_id",
          sortable: false,
          tdClass: "text-right",
          thClass: "text-right",
          width: "15%",
        },
      ],
      rows: [],
      totalRecords: 0,
      saveType: "create",
      saveId: null,
      saveIndex: null,
      selectedRows: [],
    };
  },
  methods: {
    async deleteEmployee(id, index) {
      var self = this;
      Swal.fire({
        title: "Are you sure?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete this employee!",
      }).then(async (result) => {
        if (result.value) {
          try {
            const res = await axios.delete(
              "/v2/performance_scanning/employees/" + id
            );
            if (res.data.status === "OK") {
              self.rows.splice(index, 1);
              Swal.fire("Deleted!", "", "success");
            }
          } catch (e) {
            Swal.fire("Problem deleting employee!", "", "error");
          }
        }
      });
    },
  },
};
</script>

<style scoped>
@import "~sweetalert2/dist/sweetalert2.min.css";

.search-table {
  width: 300px;
}

.modal-header .close {
  margin-top: -20px;
}

.header-button-container {
  text-align: right;
}

.create-new-button {
  height: 100%;
}

.btn-primary {
  height: 37.5px;
  border: 1px;
}

.fa-plus-circle {
  padding-top: 4.5px;
}

.vgt-checkbox-col {
  color: blue;
}
</style>
